module.exports = __webpack_public_path__ + "img/7b5b8102814a2614fb864efd15e427e4.svg";